// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.I4VUyuDunHwzh8 {
  display: grid;
  grid-template-columns: 1fr 0.5fr 0.5fr 1fr;
  grid-template-rows: auto;
  align-items: baseline;
  column-gap: var(--ds-space-200, 16px);
  justify-items: stretch;
}
.I4VUyuDunHwzh8 label {
  display: block;
  margin-top: var(--ds-space-150, 12px);
  margin-bottom: var(--ds-space-050, 4px);
}
.I4VUyuDunHwzh8._0lY7cegaxZHrmI {
  grid-template-areas: 'number number number number' 'expiration expiration expiration expiration' 'cvv cvv cvv cvv' 'country country country country' 'zip zip zip zip' 'taxid taxid taxid taxid' 'statetaxid statetaxid statetaxid statetaxid';
}
.I4VUyuDunHwzh8.wME4leXO0UBTgK {
  grid-template-areas: 'number number number number' 'expiration expiration cvv cvv' 'country country country country' 'zip zip zip zip' 'taxid taxid taxid taxid' 'statetaxid statetaxid statetaxid statetaxid';
}
.I4VUyuDunHwzh8.B3DXsku74fjAmb {
  grid-template-areas: 'number number number number' 'expiration cvv cvv .' 'country country zip zip' 'taxid taxid taxid taxid' 'statetaxid statetaxid statetaxid statetaxid';
}
.I4VUyuDunHwzh8.Kkz8jfn6v3M593 {
  grid-template-areas: 'number number number number' 'expiration cvv cvv .' 'country country zip zip' 'taxid taxid statetaxid statetaxid';
}
`, ""]);
// Exports
export var grid = `I4VUyuDunHwzh8`;
export var xsmall = `_0lY7cegaxZHrmI`;
export var small = `wME4leXO0UBTgK`;
export var medium = `B3DXsku74fjAmb`;
export var large = `Kkz8jfn6v3M593`;
export default ___CSS_LOADER_EXPORT___;
